<template>
  <div class="box">
    <div class="tabbar" :class="navBarFixed ? 'navBarFixed' : ''">
      <img @click="goback" src="../../../../static/common/logo.png" alt="" />
    </div>
    <img class="banner" src="/subject/sc_2024/banner.png" alt="" />
    <div id="login">
      <!-- <div class="logxiadan">
        <img src="/subject/sc_2024/500zj.png" alt="" />
      </div> -->
      <div class="interactive">
        <input v-model="form.phone" ref="inputElement" type="text" placeholder="请输入手机号" @blur="changePhone" />
        <div class="codeBox">
          <input v-model="form.code" type="text" placeholder="请输入验证码" />
          <span v-if="verControl" @click="verCode(form.phone)">获取验证码</span>
          <span v-else>重新获取({{ verSecond }})</span>
        </div>

        <div class="buttom" @click="submit(form)">
          立即领取
        </div>
      </div>

    </div>
    <div class="sliders">
      <div class="logdjs">
        <span class="logdjs-span logdjs-span1">{{ days }}</span><span class="logdjs-span logdjs-span2">{{ hours
          }}</span><span class="logdjs-span logdjs-span3">{{ minutes }}</span><span class="logdjs-span logdjs-span4">{{
          seconds }}</span>
      </div>
    </div>

    <div class="content">
      <div class="part">
        <div class="part1">
          <div>
            <!-- <div class="clearfix newuser"></div> -->
            <div class="clearfix">
              <span class="span1" @click="showDialog = true">活动详情</span>
            </div>
            <div class="img-box1">
              <div class="img1" @click="focusInput">
                <img src="/subject/sc_2024/cart2.png" alt="" />
                <img class="bott" src="/subject/sc_2024/button.png" alt="">
              </div>
              <div class="img2" @click="focusInput">
                <img src="/subject/sc_2024/cart1.png" alt="" />
                <img class="bott" src="/subject/sc_2024/button.png" alt="">

              </div>
              <div class="img3" @click="focusInput">
                <img src="/subject/sc_2024/cart3.png" alt="" />
                <img class="bott" src="/subject/sc_2024/button.png" alt="">

              </div>
            </div>
            <div class="neirong">
              <div class="lists">
                <div class="title">本月已累计发放<span>${{ totals }}</span>赠金</div>
                <div class="timrlist">
                  <div v-for="(item, index) in timeList" :key="index" style="width: 40%;">
                    <span><span class="name">{{ item.name }}</span> 领取了<span class="value">{{ item.value
                        }}</span>赠金</span>
                  </div>
                </div>
              </div>

            </div>
            <div class="anniu">
              <!-- <div class="anniu-div" @click="live800"></div> -->
              <img src="/subject/sc_2024/kefu.png" class="anniu-div" @click="live800" alt="">
              <img class="anniu-img" @click="focusInput" src="/subject/sc_2024/buttom.png" alt="" />
            </div>
          </div>
        </div>
        <div class="part2 clearfix">

          <div class="part2-img">
            <div class="step1">
              <img src="/subject/sc_2024/steps.png" alt="">
              <div class="txt">
                <span class="title">下载注册</span>
                <span class="title1">注册新账户，</span>
                <span class="title1">即刻领取<span class="txts">$588</span>赠金;</span>
              </div>
            </div>
            <div class="step1">
              <img src="/subject/sc_2024/steps1.png" alt="">
              <div class="txt">
                <span class="title">充值福利</span>
                <span class="title1">完成充值，获得双倍本金，</span>
                <span class="title1">领<span class="txts">$20000+￥1588</span>礼包；</span>
              </div>
            </div>
            <div class="step1">
              <img src="/subject/sc_2024/steps2.png" alt="">
              <div class="txt">
                <span class="title">入金交易</span>
                <span class="title1">开始交易，笔笔返现，</span>
                <span class="title1"><span class="txts">每手返$2-$5，</span>可提现;</span>
              </div>
            </div>
          </div>
          <div class="part2-line"></div>
          <div class="part2-img2">
            <div class="part2-content">
              <!-- <div class="title">最新黄金行情</div> -->
              <!-- <div class="titles">2024年12月26日，王先生闲暇时间打开APP，</div>
              <div class="titles">以<span class="bolds">2615.41</span>的价格买入了<span class="bolds">1手</span>伦敦金，</div>
              <div class="titles">在报价到<span class="bolds">2639.41</span>的时候果断平仓，</div>
              <div class="titles">一天的时间赚了<span class="bolds1">17000+人民币的丰厚收益。</span></div> -->
              <div class="cont-list">
                <img src="/subject/sc_2024/cont.png" alt="">
                <img src="/subject/sc_2024/cont1.png" alt="">
              </div>

            </div>
          </div>
          <div class="anniu">
            <div class="anniu-div" @click="live800"></div>
            <img class="anniu-img" @click="focusInput" src="/subject/sc_2024/buttom.png" alt="" />
          </div>
        </div>
        <div class="part3">
          <div class="craigBox">
            <ul @mouseleave="totalLeave">
              <li @mouseover="mouseOver(1)" @mouseleave="mouseLeave(1)" ref="liFirst"
                :class="controlImg.baozhiImgs ? 'bzBkgImg' : ''">

                <p :class="controlImg.baozhiImgs ? 'textColor1' : 'textColor'">
                  <span> AA类牌照</span>
                  <img src="/subject/sc_2024/icon.png" alt="">
                </p>
                <div class="wanzhengText" v-if="controlImg.baozhiImgs">

                  <div class="about-standard-item">
                    <div class="about-standard-item-title">黄金交易所AA类牌照</div>
                    <div class="about-standard-item-content">
                      实力雄厚，风控体系完善<br />
                    </div>
                  </div>

                </div>
                <img class="btmBanner" :class="controlImg.baozhiImgs ? 'OpacityImg' : ''"
                  src="/subject/sc_2024/part.png" alt="">

              </li>
              <li ref="liSecond" style="position: relative;" @mouseover="mouseOver(2)" @mouseleave="mouseLeave(2)"
                :class="controlImg.sxjzImgs ? 'sxjzBkgImg' : ''">


                <div class="wanzhengText" v-if="controlImg.sxjzImgs">
                  <div class="about-standard-item">
                    <div class="about-standard-item-title">出入金便利</div>

                    <div class="about-standard-item-content">
                      7*24小时随时存取，资金可查<br />


                    </div>
                  </div>

                </div>
                <p :class="controlImg.sxjzImgs ? 'textColor1' : 'textColor'">
                  <span>出入金便利</span>
                  <img src="/subject/sc_2024/icon.png" alt="">
                </p>
                <img class="btmBanner" :class="controlImg.sxjzImgs ? 'OpacityImg' : ''" src="/subject/sc_2024/part1.png"
                  alt="">

              </li>
              <li ref="liThird" @mouseover="mouseOver(3)" @mouseleave="mouseLeave(3)"
                :class="controlImg.sctmImgs ? 'sctmBkgImg' : ''">
                <p :class="controlImg.sctmImgs ? 'textColor1' : 'textColor'">
                  <span>活动丰富</span>
                  <img src="/subject/sc_2024/icon.png" alt="">
                </p>
                <div class="wanzhengText" v-if="controlImg.sctmImgs">
                  <div class="about-standard-item">
                    <div class="about-standard-item-title">优惠活动丰富</div>
                    <div class="about-standard-item-content">
                      交易低点差，注册送交易送<br />
                    </div>
                  </div>
                </div>
                <img class="btmBanner" :class="controlImg.sctmImgs ? 'OpacityImg' : ''" src="/subject/sc_2024/part2.png"
                  alt="">
              </li>
              <li ref="liFourth" @mouseover="mouseOver(4)" @mouseleave="mouseLeave(4)"
                :class="controlImg.jylhImgs ? 'jylhkgImg' : ''">

                <p :class="controlImg.jylhImgs ? 'textColor1' : 'textColor'">
                  <span>行情掌控</span>
                  <img src="/subject/sc_2024/icon.png" alt="">

                </p>
                <div class="wanzhengText" v-if="controlImg.jylhImgs">
                  <div class="about-standard-item">
                    <div class="about-standard-item-title">行情实时掌控</div>
                    <div class="about-standard-item-content">
                      毫秒级精准报价，多种图表支持<br />
                    </div>
                  </div>
                </div>
                <img class="btmBanner" :class="controlImg.jylhImgs ? 'OpacityImg' : ''" src="/subject/sc_2024/part3.png"
                  alt="">
              </li>

            </ul>
          </div>
        </div>
      </div>
      <contactus-vue></contactus-vue>

    </div>
    <div class="sliderBox" v-if="slider">
      <!-- <img class="allCode" src="/subject/invest/downloadNew.png" alt="" /> -->
      <Qrcode :link="qrCodeUrl" :size="140" />
      <img @click="slider = false" class="user-info-close" src="/subject/sc_2024/close.png" alt="" />
    </div>
    <div v-if="showDialog" class="dialog">
      <img class="closer" @click="showDialog = false" src="/subject/mayPage/closer.png" alt="" />
      <ul class="dialogContent">
        <h3>新用户活动规则</h3>
        <li>
          <span>活动对象：</span><br />
          活动期间，在本平台首次开立真实账户，及首次入金的客户
        </li>
        <li>
          <span>活动时间：</span><br />
          即日起至{{ formattedDateString }}
        </li>
        <li style="color:#ad0000">
          <span>活动规则：</span><br />
          活动期间，新用户可享双重福利：<br />
          1. 开户领$588美元赠金，交易后可提现；<br />
          2. 首次入金，最高领$20000+￥1588新人礼包！
        </li>
        <li>
          <span>开户领$588美元赠金：</span><br />
          完成首次开户 领$588美元赠金，有效期90天内每交易一手伦敦金/伦敦银，获得相对应的赠金金额返还（未满一手按照实际交易手数占一手的比例计算）<br />
          <img src="/subject/mayPage/table100.png" alt="" />
        </li>
        <li>
          <span>首入金领$20000+￥1588</span><br />
          首次充值，送美元赠金+美元现金+人民币红包；<br />
          24小时内充多少送多少，最高领$20000+￥1588 迎新大礼包；<br />
          首入金奖励如下：<br />
        </li>
        <li>
          <img src="/subject/mayPage/table200.png" alt="" />
        </li>
        <li>
          <span>美元赠金：</span><br />
          1、活动期间内，首次入金可获得等额的美元赠金（即赠金点）回馈；<br />
          2、
          首入金有效期为第一笔入金后的24h内，充多少送多少；<br />
          3、用户每交易一手伦敦金/伦敦银，返还相对应的赠金金额；该笔资金可交易可提现，用户可登录App-我的-赠金奖励中查看（未满一手按照实际交易手数占一手的比例计算）<br />
          4、美元赠金按交易手数返还，当月交易越多，每手返还越高！<br />
          <span style="color:#000000">
            更多活动详情，请下载App-我的-赠金奖励中查看，或咨询客服。
          </span>
        </li>
        <li>
          <span>美元现金：</span><br />
          1、美元现金直接入账，可交易，可提现；<br />
          2、用户在30天内完成指定交易手数即可提现，品种限伦敦金/伦敦银；<br />
          3、30天内未达到交易手数要求，或者活动期间取款时未完成对应手数交易，系统将收回美元现金金额；<br />
          举例说明：A女士，入金500美元，到账600美元，入金后30天内完成了20手交易，将100美元现金提现
        </li>
        <li>
          <span>注意事项：</span><br />
          1.
          客户参与活动需在本公司开立真实交易账户,参与该活动的新用户，为保证资金安全，在初始L1层级，账户强平比例上调至50%，升级后自动恢复为30%；<br />
          2. 交易手数计算：开仓一手平仓一手，如此来回算一手；<br />
          3. 本活动本公司新客户仅有一次机会参与，不可重复领取；<br />
          4.
          本公司保留随时修订、暂停、终止本活动及任何相关规则条款之权利及其解释权。
        </li>
      </ul>
    </div>
    <div class="dark" v-if="showDialog" @click="showDialog = false"></div>
  </div>
</template>

<script>
import ContactusVue from "@/component/base-footer";
import { queryConfigValue, getFakebonus } from '@/apis/common';
import userSign from '@/mixins/userSign';

import Qrcode from '@/component/QrCode/index.vue'
export default {
  components: {
    ContactusVue,
    Qrcode,
  },
  mixins: [ userSign ],
  data() {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      navBarFixed: false,
      scroll: "",
      screenWidth: null,
      slider: true,
      showDialog: false,
      formattedDateString: '',
      timer: null,
      qrCodeUrl: '',
      timeList: [
        { name: '85***12', value: '156.93美元' },
        { name: '85***22', value: '260.35美元' },
        { name: '85***32', value: '543.11美元' },
        { name: '85***42', value: '10012.93美元' },
      ],
      totals: 10000,

      animate: 0,
      // 控制craigBox
      controlImg: {
        baozhiImgs: true,
        sxjzImgs: false,
        sctmImgs: false,
        jylhImgs: false,
        yzsImgs: false
      },
      // 控制serveBox
      controlDiv: 1,

    };
  },

  mounted() {
    //获取屏幕尺寸
    this.screenWidth = document.body.clientWidth;
    window.addEventListener("scroll", this.handleScroll);
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
    window.setInterval(function () {
      var refreshHours = new Date().getHours();
      var refreshMin = new Date().getMinutes();
      var refreshSec = new Date().getSeconds();
      if (refreshHours == '8' && refreshMin == '0' && refreshSec == '0') {
        // 指定每天凌晨做的事情
        this.totals = this.getTotal()

      }
    }, 1000);
    this.getActivityTime();
    const channel = sessionStorage.getItem('channel');
    this.qrCodeUrl = 'https://sem.rlcmarketltd.net/subject/download?channel=' + channel
    this.scrollList()

  },
  destroyed() {
    clearInterval(this.timer);
  },
  watch: {
    screenWidth: function (n) {
      if (n <= 500) {
        this.$router.push({
          name: "sc_2024wap",
          query: this.$route.query || {},
        });
      }
    },
  },
  created() {
    this.$emit("controlShow", true);
    this.getTime()
    this.getTotal()

    this.getData()

  },
  methods: {
    getTime() {
      const today = new Date()
      const time = today.getTime()
      let endDate = new Date(this.getNextMonthFirstDay()); // this.curStartTime需要倒计时的日期
      let end = endDate.getTime();
      if (time == end || end - time == 0) {
        this.totals = this.getTotal()
     

      }
    },
    // 获取下个月时间
    getNextMonthFirstDay() {
      const today = new Date();
      const nextMonthFirstDay = new Date(today.getFullYear(), today.getMonth() + 1, 1);
      console.log(nextMonthFirstDay.toISOString().split('T'))
      return nextMonthFirstDay.toISOString().split('T')[0] + ' ' + '23' + ':' + '59' + ':59';
    },
    // 获取轮播数据
    getData() {
      for (let i = 0; i <= 21; i++) {
        this.timeList.push({ name: '85***' + this.fullOpen(10, 100), value: this.fullOpens(150, 11000) + '美元' })
      }
      console.log(this.timeList)
    },

  
    //生成随机数据
    fullOpen(n, m) {
      var result = Math.floor(Math.random() * (m - n) + n);
      while (result == n) {
        result = Math.floor(Math.random() * (m - n) + n);
      }
      return result;
    },
    fullOpens(n, m) {
      var result = (Math.random() * (m - n) + n).toFixed(2);
      while (result == n) {
        result = (Math.random() * (m - n) + n).toFixed(2);
      }
      return result;
    },

    // 列表滚动
    scrollList() {
      const swiperList = document.getElementsByClassName("timrlist");
      console.log('--------------', swiperList)
      this.animate = setInterval(() => {
        for (let i = 0; i < swiperList.length; i++) {
          let maxtop = swiperList[i].scrollHeight - swiperList[i].offsetHeight;
          if (maxtop === 0) {
            continue;
          }
          swiperList[i].scrollTop += 1
          if (swiperList[i].scrollTop >= (maxtop - 1)) {
            swiperList[i].scrollTop = 0
          }
        }
      }, 80);
    },
    async getActivityTime() {
      const res = await queryConfigValue({"key":"SCjiezhishijian"})
      if(!res) { return}
      this.updateCountdown(res.replace(/-/g, '/'));
      this.timer = setInterval(() => this.updateCountdown(res.replace(/-/g, '/')), 1000);
      this.formattedDateString = this.formatDates(res);  
    },
    formatDates(dateString) {
      // 解析日期时间字符串  
      const date = new Date(dateString);

      // 检查日期是否有效  
      if (isNaN(date.getTime())) {
        throw new Error('Invalid date string');
      }

      // 使用模板字符串格式化日期和时间  
      const formattedDate = `${date.getFullYear()}年${padZero(date.getMonth() + 1)}月${padZero(date.getDate())}日${padZero(date.getHours())}:${padZero(date.getMinutes())}`;

      return formattedDate;

      // 辅助函数：在数字前面添加前导零（如果需要）  
      function padZero(num) {
        return num.toString().padStart(2, '0');
      }
    },
    // 点击获取焦点
    focusInput() {
      this.$refs.inputElement.focus();
    },
    updateCountdown(needTime) {
      const today = new Date();
      const endOfMonth = new Date(needTime).getTime();
      // const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      let timeLeft = endOfMonth - today;
      if (timeLeft <= 0) {
        timeLeft = 0
        clearInterval(this.timer)
      }
      this.days = String(Math.floor(timeLeft / (1000 * 60 * 60 * 24))).padStart(
        2,
        "0"
      );
      this.hours = String(
        Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      ).padStart(2, "0");
      this.minutes = String(
        Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))
      ).padStart(2, "0");
      this.seconds = String(
        Math.floor((timeLeft % (1000 * 60)) / 1000)
      ).padStart(2, "0");
    },
    // 返回上级页面
    goback() {
      window.location.href = window.location.origin;
    },
    // 控制顶部的定位
    handleScroll() {
      this.scroll =
        document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
      if (this.scroll > 90) {
        this.navBarFixed = true;
      } else {
        this.navBarFixed = false;
      }
    },
    // 提交手机号验证码
    submit(form) {
      if(form.phone && form.code){
        this.handleRegister().then(() => {
          setTimeout(() => {
            this.toUserCenter();
          }, 500)
        }).catch(() => {
        })
      }else{
        this.$message({
          message: '请输入手机号和验证码！',
          type: 'warning',
        });
      }
    },
    // 回到顶部
    toTop() {
      document.documentElement.scrollTop = 0;
    },
    //获取当月最后一天的日期
    getLastDay() {
      var year = new Date().getFullYear(); //获取年份
      var month = new Date().getMonth() + 1; //获取月份
      var lastDate = new Date(year, month, 0).getDate(); //获取当月最后一日
      month = month < 10 ? "0" + month : month; //月份补 0
      return year + "年" + month + "月" + lastDate + "日 23:59:59";
    },
    // 鼠标移入事件
    mouseOver(attr) {
      switch (attr) {
        case 1:
          this.controlImg.baozhiImgs = true;
          break;
        case 2:
          this.controlImg.sxjzImgs = true;
          this.controlImg.baozhiImgs = false;
          break;
        case 3:
          this.controlImg.sctmImgs = true;
          this.controlImg.baozhiImgs = false;
          break;
        case 4:
          this.controlImg.jylhImgs = true;
          this.controlImg.baozhiImgs = false;
          break;
        case 5:
          this.controlImg.yzsImgs = true;
          this.controlImg.baozhiImgs = false;
          break;
      }
    },
    // 鼠标移出事件
    mouseLeave(attr) {
      switch (attr) {
        case 1:
          this.controlImg.baozhiImgs = false;
          break;
        case 2:
          this.controlImg.sxjzImgs = false;
          break;
        case 3:
          this.controlImg.sctmImgs = false;
          break;
        case 4:
          this.controlImg.jylhImgs = false;
          break;
        case 5:
          this.controlImg.yzsImgs = false;
          break;
      }
    },
    // 鼠标移出整个box时，设置默认展开栏
    totalLeave() {
      this.controlImg.baozhiImgs = true;
    },

    // 获取数据总和
    getTotal(){
      getFakebonus().then(res=>{
        console.log('zonghe-------',res)
    
          this.totals = Number(res) 

        
      })
      
    }
  },
  deactivated() {
    clearInterval(this.animate)
  },
  beforeDestroy() {
    clearInterval(this.animate)
  }
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  // overflow-x: hidden;
  // height: 6215px;
  background: #F8E3C1;

  .tabbar {
    width: 100%;
    background-color: #ffffff;

    img {
      margin: 20px 50px;
      width: 130px;
    }
  }

  .navBarFixed {
    position: fixed;
    top: 0;
    z-index: 999;
  }

  .banner {
    width: 100%;

    display: block;
  }

  #login {
    width: 20%;
    height: 8.5vw;
    margin: 0 auto;
    background: url(/subject/sc_2024/submit.png) no-repeat;
    background-size: 100% 100%;
    border-radius: 10px;
    padding: 132px 0 58px;
    position: absolute;
    top: 10vw;
    right: 13%;
    transform: translate(-50%, 0);

    .logxiadan {
      width: 70%;
      margin: 0 auto;
      margin-bottom: 10px;

      img {
        width: 100%;
      }
    }

    .interactive {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      input:focus {
        outline: none;
      }

      input {
        width: 80%;
        height: 2vw;
        background: #fff;
        border: 1px solid #fff;
        border-radius: 10px;
        font-size: 16px;
        text-indent: 25px;
        list-style: none;
        border: 1px solid #e6e6e6;
      }

      .codeBox {
        width: 80%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 16px 0 26px 0;

        input {
          width: 100%;
        }

        span {
          width: 160px;
          height: 2.2vw;
          line-height: 2.2vw;
          font-size: 16px;
          border-radius: 10px;
          background: linear-gradient(to bottom, #ffefcc, #ffc994);
          width: 142px;

          background: #ff1220;

          text-align: center;
          color: #fff;
          position: absolute;
          top: 0vw;
          right: 0px;
          cursor: pointer;
        }
      }

      .loginBtn {
        width: 20%;
        cursor: pointer;
        position: relative;
        top: 15px;
      }
    }


    .buttom {
      width: 240px;
      height: 54px;
      background: #ff1220;
      border-radius: 8px;
      text-align: center;
      line-height: 54px;
      color: #fff;
      font-size: 22px;
      font-weight: 700;
    }

  }

  .sliders {
    position: absolute;
    top: 34vw;
    left: 25%;
    width: 50%;
    margin: 0 auto;
    height: 10.8vw;
    line-height: 7.8vw;
    text-align: center;
    background: url(/subject/sc_2024/slider.png) no-repeat center;
    background-size: 100% 100%;
    font-size: 2vw;
    color: #fff2d5;
  }

  .logdjs {


    // position: relative;

    .logdjs-span {
      display: inline-block;
      // width: 4.5vw;
      // height: 4.7vw;
      margin: 0 5px;
      line-height: 4.7vw;
      text-align: center;
      font-size: 2.5vw;

      border-radius: 16px;

      color: #FFF;

    }

    .logdjs-span1 {
      position: absolute;
      top: 29%;
      left: 26%;
    }

    .logdjs-span2 {
      position: absolute;
      top: 29%;
      left: 37%;
    }

    .logdjs-span3 {
      position: absolute;
      top: 29%;
      left: 47.5%;
    }

    .logdjs-span4 {
      position: absolute;
      top: 29%;
      left: 58.5%;
    }
  }

  .content {
    width: 100%;
    height: auto;
    // height: 5627px;
    box-sizing: border-box;
    margin: 0 auto;
    position: absolute;
    top: 46vw;
    background-size: 100% 90%;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.1)10%, #F8E8C8 11%, #F8E8C8 100%);

    .parent-container {
      display: flex;
      justify-content: center;
      align-items: center;

      .dujia {
        margin-top: 130px;
      }
    }

    .part {
      // max-width: 1400px;
      width: 73%;
      margin: 0 auto;
      padding: 0% 13% 10%;


      .part1 {
        box-sizing: border-box;
        // width: 1377px;
        // height: 1497px;
        max-width: 1377px;
        padding: 16% 13% 10%;

        background: url(/subject/sc_2024/001.png) no-repeat center center;
        background-size: 100% 100%;
        margin: 0 auto;

        .clearfix {
          width: 105px;
          height: 40px;
          margin: 0 auto;
          // margin-top: 45px;
          margin-bottom: 45px;

          .span1 {
            text-decoration: underline;
            // position: absolute;
            // top: -30px;
            // left: 0;
            // margin-top: -30px;
            display: block;
            // width: 33%;
            text-align: center;
            // margin-left: 371px;
            font-size: 25px;
            color: #c0705e;
            cursor: pointer;
          }
        }

        .clearfix::after {
          content: "";
          display: table;
          clear: both;
        }

        .newuser {
          width: 556px;
          height: 73px;
          margin: 0 auto;
          background: url(/subject/sc_2024/newuser.png) no-repeat center;
          background-size: 100%;
          margin-top: 60px;
        }

        .img-box1 {
          display: flex;
          justify-content: center;
          margin-bottom: 40px;

          .img1,
          .img2,
          .img3 {
            width: 260px;
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;

            img {
              width: 100%;
            }

            .bott {
              width: 196px;
              margin-top: 16px;
            }
          }

          .img2 {
            margin: 0 2%;
          }
        }

        .img-box2 {
          margin-bottom: 50px;
          padding-left: 100px;

          .jia {
            margin-bottom: 122px;
            margin-left: 50px;
          }
        }

        .youhui {
          font-size: 32px;
          color: #333;
          margin: 0 auto;
          width: 50%;
          height: 60px;
          line-height: 60px;
          text-align: center;
          display: flex;
          margin-bottom: 20px;

          img {
            margin-right: 10px;
          }

          i {
            font-style: normal;
            /* 取消斜体 */
            color: red;
            /* 设置文本颜色为红色 */
          }
        }

        .neirong {
          // width: 780px;
          height: 188px;
          margin: 0 auto;
          text-align: center;
          position: relative;
          padding: 98px 0 64px 0;
          background: url('/subject/sc_2024/time.png') no-repeat center;
          background-size: 100% 100%;

          .title {
            position: absolute;
            top: 6%;
            left: 33%;
            font-size: 24px;
            font-weight: 700;
            text-align: center;
            color: #965f00;

            span {
              color: #e50000;
            }
          }

          .timrlist {
            display: flex;
            // flex-direction: column;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            padding: 0px 0 36px;
            font-size: 16px;
            width: 100%;
            height: 160px;
            color: #333;
            box-sizing: border-box;
            overflow: hidden scroll;
            overflow-y: hidden;
            margin-top: 20px;

            div {
              margin-bottom: 18px;
            }

            .name {
              font-weight: 700;

            }

            .value {
              color: #e50000;

            }

          }

          h1 {
            color: #C0614B;
            font-size: 40px;
          }

          p {
            color: #E80F0F;
            font-size: 26px;
            font-weight: bold;
          }

          .p2 {
            color: #C0614B;
            font-size: 32px;
            margin-top: 30px;
          }

          .b1 {
            position: absolute;
            left: 0;
            top: 0;
          }

          .b2 {
            position: absolute;
            right: 0;
            top: 0;
          }
        }

        .anniu {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 32px;

          .anniu-div {
            width: 190px;
            height: 46px;
            margin-right: 2%;
            // background: url(/subject/newYear9911/serve.png) no-repeat ;
            // background-size: 100% 100%;
          }

          .anniu-img {
            width: 248px;
            height: 46px;
          }
        }
      }

      .part2 {

        max-width: 1377px;
        // width: 1377px;
        // height: 1497px;
        // height: 813px;
        margin: 0 auto;
        margin-top: 155px;
        padding: 16% 13% 10%;
        background: url(/subject/sc_2024/002.png) no-repeat center;
        background-size: 100% 100%;
        background-position: center;

        /* 填充整个小div */
        .clearfix::after {
          content: "";
          display: table;
          clear: both;
        }

        .line260 {
          width: 100%;
          height: 260px;
          margin: 0 auto;
        }

        .part2-img {
          // width: 1255px;
          // height: 360px;
          margin: 0 auto;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;

          img {
            width: 81px;
            height: 80px;
            margin-right: 13px;
          }

          .step1 {
            display: flex;
            align-items: center;
          }

          .txt {
            display: flex;
            flex-direction: column;
          }

          .title {

            font-size: 20px;
            font-weight: 700;
            text-align: left;
            color: #dc9948;
          }

          .title1 {

            font-size: 16px;

          }

          .txts {
            color: #e50000;
            font-weight: 700;
          }

          // background: url(/subject/newYear9911/step.png) no-repeat center;
          // background-size: 100%;
        }

        .part2-line {
          width: 100%;
          height: 0px;
          background: linear-gradient(-90deg, #d69450 0%, #f2c178 100%);
          border: 1px dashed #d69450;
          margin-top: 35px;
        }

        .part2-img2 {
          max-width: 921px;
          // width: 921px;
          // height: 689px;
          // margin: 0 auto;
          // background: url(/subject/newYear9911/step1.png) no-repeat center;
          // background-size: 100%;
          margin-top: 40px;

          img {
            width: 100%;
          }

          .part2-content {
            .title {
              margin-bottom: 23px;
              font-size: 26px;

              font-weight: 700;
              text-align: left;
              color: #dc9948;
            }

            .titles {

              font-size: 18px;
              text-align: left;
              color: #333333;
              line-height: 36px;
            }

            .bolds {
              color: #e50000;
            }

            .bolds1 {
              color: #e50000;
              font-weight: 700;
              font-size: 24px;
            }
          }
          .cont-list{
            img{
              width: 220px;
              height: auto;
            }
          }
        }

        .part2-text {
          width: 100%;
          width: 50%;
          margin: 0 auto;
          font-size: 32px;
          color: #333333;

          .part2-text-span1 {
            color: #e26060;
          }

          .part2-text-span2 {
            color: #333333;
          }
        }

        .anniu {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          // position: relative;
          // top: -40px;
          margin-top: 35px;

          .anniu-div {
            width: 190px;
            height: 46px;
            background: url(/subject/sc_2024/kefu.png) no-repeat center;
            background-size: 100%;
            margin-right: 18px;
          }
        }
      }

      .part3 {
        max-width: 1377px;
        // width: 1377px;
        // height: 1718px;
        margin: 0 auto;
        margin-top: 100px;
        padding-top: 10%;
        margin-bottom: 90px;
        background: url(/subject/sc_2024/003.png) no-repeat center;
        background-size: 100% 100%;
        background-position: center;
        padding-bottom: 30px;

        .line260 {
          max-width: 1377px;
          // width: 1377px;
          height: 260px;
          margin: 0 auto;
        }

        .con {
          width: 100%;
          margin: 0 auto;
          max-width: 1280px;
          box-sizing: border-box;
          padding: 0 50px;

          ul {
            margin-bottom: 30px;

            li {
              display: inline-block;
            }
          }

          ul li:nth-child(1) {
            margin-right: 60px;
          }

          p {
            font-size: 36px;
            color: #73462F;
            text-align: center;

            b {
              font-weight: normal;
              color: #CC2A2A;
            }
          }
        }

        .anniu {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          top: 20px;

          .anniu-div {
            width: 362px;
            height: 155px;
            background: url(/subject/newYear9911/serve.png) no-repeat center;
            background-size: 100%;
          }
        }
      }
    }
  }

  .sliderBox {
    width: 360px;
    height: 440px;
    background: url(/subject/sc_2024/dialog.png) no-repeat;
    background-size: 100% 100%;
    position: relative;
    position: fixed;
    top: 50%;
    right: 0;
    padding-left: 24px;
    transform: translate(0%, -50%);
    text-align: center;
    line-height: 580px;

    .allCode {
      width: 140px;
    }

    .user-info-close {
      position: absolute;
      bottom: -60px;
      left: 50%;
      z-index: 5;
      transform: translate(-50%, 0);
      cursor: pointer;
    }
  }

  .dialog {
    position: relative;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 800px;
    height: 580px;
    box-shadow: 0px 0px 95px 0px rgba(187, 188, 192, 0.1);
    background-color: #fff;
    border-radius: 14px;
    overflow-y: scroll;
    z-index: 99999999;

    .closer {
      width: 25px;
      height: auto;
      position: absolute;
      top: 8px;
      right: 8px;
      cursor: pointer;
    }

    .dialogContent {
      box-sizing: border-box;
      padding: 15px;
      overflow: hidden;
      background: url("/subject/mayPage/rulesBackground.png") no-repeat;
      background-size: 100% 100%;

      h3 {
        color: #d88f4f;
        text-align: center;
      }

      li {
        font-size: 16px;
        color: #464646;
        line-height: 34px;

        span {
          font-weight: 600;
          color: #d88f4f;
        }

        img {
          width: 100%;
          height: auto;
          margin: 20px 0;
        }

        table {
          width: 100%;
          border: 1px solid #464646;
          border-radius: 10px;

          tr {
            th {
              text-align: center;
              font-weight: 500;
              line-height: 24px;
              border-bottom: 1px solid #464646;
              border-right: 1px solid #464646;
              padding: 5px;
            }

            th:last-child {
              border-right: 1px solid transparent;
            }
          }

          tr:nth-child(1) {
            th {
              font-weight: 600;
            }
          }
        }
      }
    }

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background-color: #fedfba;
      -webkit-border-radius: 2em;
      -moz-border-radius: 2em;
      border-radius: 2em;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #d88f4f;
      -webkit-border-radius: 2em;
      -moz-border-radius: 2em;
      border-radius: 2em;
    }
  }

  .dark {
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.5;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 101;
  }
}

.craigBox {
  width: 100%;
  box-sizing: border-box;
  padding: 60px 0;
  // background: #fff;
  background-size: cover;

  ul {
    width: 1000px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;

    li {
      width: 20%;
      height: 394px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-start;
      box-sizing: border-box;
      border-right: 5px solid #f8f8f8;
      padding: 50px 0 0 0px;
      position: relative;
      background-color: #fff;

      .btmBanner {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 170px;
        height: 394px;
      }

      p {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        position: absolute;
        bottom: 0px;
        left: 10px;
        z-index: 10;
        width: 170px;
        // height: 246px;
        padding: 71px 0 56px 0;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 28.5%, rgba(0, 0, 0, 0.8) 100%);

        img {
          margin-top: 61px;
        }

        span {
          font-size: 14px;
          color: #6d6d6d;
        }

        span:nth-child(1) {
          font-size: 16px;
          font-weight: 600;
          color: #121212;
        }
      }
    }

    .wanzhengText {
      width: 65%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end !important;
      align-items: flex-start;

      p {

        color: #fff;
        margin: 0;
        text-align: justify;
        line-height: 26px;

      }

      p:nth-child(2) {
        font-size: 22px;
        color: #fff;
        margin: 30px 0 10px;
      }
    }

    .bzBkgImg {
      background: url('/subject/sc_2024/parts.png') no-repeat;
      background-size: cover;
      width: 45%;

    }

    .sxjzBkgImg {
      background: url('/subject/sc_2024/parts1.png') no-repeat;
      background-size: cover;
      width: 45%;
    }

    .sctmBkgImg {
      background: url('/subject/sc_2024/parts2.png') no-repeat;
      background-size: cover;
      width: 45%;
    }

    .jylhkgImg {
      background: url('/subject/sc_2024/parts3.png') no-repeat;
      background-size: cover;
      width: 45%;
    }

    li .textColor span {
      color: #fff !important;

    }

    li .textColor1 {
      display: none;
    }

    li .OpacityImg {
      height: 394px;
      display: none;
    }
  }

  .about-standard {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    &-item {
      width: 446px;
      height: 336px;
      color: #FFFFFF;
      // margin-bottom: 28px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      /* 垂直居下 */
      box-sizing: border-box;
      padding: 30px;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 28.5%, rgba(0, 0, 0, 0.8) 100%);




      &-title {
        font-size: 26px;
        font-weight: 700;
      }

      &-content {
        line-height: 28px;
      }
    }
  }
}

@media screen and (min-width: 1264px) and (max-width: 1700px) {
  .box {
    #login {
      width: 20%;
      height: 7.5vw;
      margin: 0 auto;
      background: url(/subject/sc_2024/submit.png) no-repeat;
      background-size: 100% 100%;
      border-radius: 10px;
      padding: 72px 0 58px;
      position: absolute;
      top: 10vw;
      right: 13%;
      transform: translate(-50%, 0);

      .interactive {
        input {
          font-size: 12px;
        }

        .codeBox {
          span {
            width: 82px;
            font-size: 12px;
          }
        }
      }

      .buttom {
        width: 154px;
        height: 36px;
        background: #ff1220;
        border-radius: 8px;
        text-align: center;
        line-height: 36px;
        color: #fff;
        font-size: 16px;
        font-weight: 700;
      }

    }

    .content {
      background: linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.1)5%, #F8E8C8 6%, #F8E8C8 100%);

      .part {
        .part1 {
          .clearfix {
            margin-top: 45px;

          }

          .neirong {

            .title {
              font-size: 18px;
              left: 31%;
            }

          }
        }
      }

      .craigBox {
        ul {
          width: 800px;

          li {
            .btmBanner {
              width: 136px;
            }

            p {
              width: 136px;
              left: 7px;
            }
          }

        }

        .about-standard {
          &-item {
            width: 350px;
          }
        }
      }
    }
  }
}
</style>
